import Vue from 'vue';
import VueRouter from 'vue-router';
import Stub from './views/misc/Stub.vue';

import store from './store';

Vue.use(VueRouter);

// navigation guard to redirect to login page
const requireAuth = (to, from, next) => {
	if (!store.state.user) {
		next({ name: 'Signin' });
	} else {
		next();
	}
};

const redirectIfLoggedIn = (to, from, next) => {
	if (store.state.user) {
		next({ name: 'ProjectSelect' });
	} else {
		next();
	}
};

export default new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			redirect: { name: 'ProjectSelect' },
		},
		{
			path: '/signin',
			name: 'Signin',
			component: () => import('@/views/user/Signin.vue'),
			beforeEnter: redirectIfLoggedIn,
		},
		{
			path: '/reset-password',
			name: 'ResetPassword',
			component: () => import('@/views/user/ResetPassword.vue'),
		},
		{
			path: '/invite',
			name: 'Invite',
			component: () => import('@/views/user/Invite.vue'),
			beforeEnter: requireAuth,
		},
		{
			path: '/signup',
			name: 'SignUp',
			component: () => import('@/views/user/Signup.vue'),
		},
		{
			path: '/terms_of_service',
			name: 'TermsOfService',
			component: () => import('@/views/user/TermsOfService.vue'),
		},
		{
			path: '/email-confirmation/:confirmationCode',
			name: 'EmailConfirmation',
			component: () => import('@/views/user/Signup.vue'),
		},
		{
			path: '/change-password',
			name: 'ChangePassword',
			component: Stub,
			beforeEnter: requireAuth,
		},
		{
			path: '/projects',
			name: 'ProjectSelect',
			component: () => import('@/views/project/ProjectDetail.vue'),
			beforeEnter: requireAuth,
		},
		{
			path: '/scenarios/:scenarioId',
			name: 'ScenarioEdit',
			props: true,
			component: () => import('@/views/project/ProjectDetail.vue'),
			beforeEnter: requireAuth,
		},
		{
			path: '/payment-info',
			name: 'PaymentInfo',
			component: () => import('@/views/misc/PaymentInfo.vue'),
			beforeEnter: requireAuth,
		},
		{
			path: '/license',
			name: 'License',
			component: () => import('@/views/misc/License.vue'),
		},
		{
			path: '/apidocs',
			name: 'ApiDocumentation',
			component: () => import('@/views/misc/ApiDocumentation.vue'),
		},
	],
});
